import { Dot } from "components/Dot";
import LinkedShowLines from "components/LinkedShows/LinkedShowElement";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import React from "react";
import { ShowSidePanel } from "./Show/ShowSidePanel";

interface SidePanelLinkedShowListProps {
  linkedShows: server.dto.LinkedShow[]
}

export const SidePanelLinkedShowList = (props: SidePanelLinkedShowListProps) => {
  const items = props.linkedShows || [];

  return <div className="flex-column gap">
    <h3>{site.currentEnvironment.show.plural}</h3>
    {items.length === 0 && <NoDataAvailableDiv />}

    {items.length > 0 && <>
      {items.map(show => <ShowSidePanel
        canEdit
        onChange={() => { }}
        showId={show.showId}
        key={show.showId}
        trigger={<a className="flex gap-small linked-show-row linked-show-link regular" style={{ cursor: "pointer", textDecoration: "none" }}>
          <div>
            <Dot color={show.status.hexColor} />
          </div>
          <div>
            <LinkedShowLines {...show} format={"regular"} />
          </div>
        </a>}
      />)}
    </>}
  </div>
}